import { render, staticRenderFns } from "./SingleProduct.vue?vue&type=template&id=63e0069c&scoped=true"
import script from "./SingleProduct.vue?vue&type=script&lang=js"
export * from "./SingleProduct.vue?vue&type=script&lang=js"
import style0 from "./SingleProduct.vue?vue&type=style&index=0&id=63e0069c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0069c",
  null
  
)

export default component.exports